import default_company from '../../assets/image/default_company.png';
import { Container } from './styled';
import { useAuth } from '../../contexts/auth';

export function BannerCompany() {

    const { company } = useAuth()

    const data = JSON.parse(company)

    const isLongName = data?.nome?.length > 30

    return (
        <Container longname={isLongName ? 'true' : undefined}>
            <div>
                <img
                    src={(data?.avatar) ? data?.avatar : default_company}
                    alt="avatar-company"
                />
            </div>
            <div>
                <span>
                    {data?.nome}
                </span>
                <span>
                    {data?.descricao}
                </span>
            </div>
        </Container>
    )
}